import React from 'react';
import { SegmentContainer } from '../../global.styles';
import { useTheme, white, grey } from '../../features/dark-mode/ThemeContext';
import { Image } from 'semantic-ui-react';
import { LinkContainer } from '../../global.styles';

const Sidebar = ({ rentalItem }) => {

  const theme = useTheme();
  const borderColor = theme.dark ? white : grey;

  return (
    <SegmentContainer.Group style={{ borderColor }}>
      <SegmentContainer>
        <h4> Owner </h4>
        <LinkContainer to={`/user_profile/${rentalItem?.ownerUid}`}>
        <Image
          src={rentalItem?.ownerImage || '/images/user.png'}
          size='mini'
          avatar
        />
        <span> {rentalItem?.displayName}</span>
        </LinkContainer>
      </SegmentContainer>
      <SegmentContainer> 
       <h4> Confirmation required </h4>
       <p style={{ color: 'teal' }}> {rentalItem?.confirmation_required === 'yes' ? 'You need to contact owner before renting this equipment' : 'No'}</p> 
      </SegmentContainer>
      <SegmentContainer column='true'>
        <h4> Full day </h4>
        <p> ${`${rentalItem?.full_day_price}.00`}</p>
      </SegmentContainer>
      <SegmentContainer column='true'>
        <h4> Half day </h4>
        <p> ${`${rentalItem?.half_day_price}.00`}</p>
      </SegmentContainer>
      <SegmentContainer column='true'>
        <h4> Instructions </h4>
        <p>{rentalItem?.instructions} </p>
      </SegmentContainer>
      <SegmentContainer column='true'>
        <h4> Region </h4>
        <p> {rentalItem?.region}</p>
      </SegmentContainer>
      <SegmentContainer column='true'>
        <h4> Delivery available </h4>
        {rentalItem?.delivery === 'yes' ? <p> Yes. Please contact the owner directly to arrange</p> : <p> No</p>}
      </SegmentContainer>
    </SegmentContainer.Group>
  );
};

export default Sidebar;
